import type { ServiceLinkEntry } from "@/lib/serviceLinkTypes";

/**
 * Batch 62 — GoHighLevel expert VA exact-match cluster service links.
 *
 * Every Batch 62 article routes its primary commercial link to
 * /gohighlevel-revops-architect. The answer-first leads in batch62Content.ts
 * embed the link directly, but the lead-swap idempotency guard can drop the
 * lead when the Quick Answer duplicates the lead text. This map is the
 * RELIABLE fallback: `injectBatchServiceLink` (batchContentOptimizer.ts) wraps
 * the first in-body occurrence of each anchor phrase in a
 * /gohighlevel-revops-architect link, so the contextual service link always
 * renders regardless of the lead swap.
 *
 * Anchors are distinctive body phrases (not in the H1) so the link injects
 * into the article body, never the headline.
 */
export const BATCH62_SERVICE_LINKS: Record<string, ServiceLinkEntry> = {
  "gohighlevel-expert-va": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /general VA with no GoHighLevel build is a VA who stalls on the system/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "hire-gohighlevel-expert-va": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /certified user with a badge and no snapshot is a user who caps at the toggle/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "gohighlevel-expert-va-cost": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /general VA at the low rate who ships no snapshot is a VA who caps at the data entry/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "what-does-a-gohighlevel-expert-va-do": {
    url: "/gohighlevel-revops-architect",
    anchor: /general VA who logs the hours is the VA who caps at the task/i,
    label: "hire a GoHighLevel RevOps architect",
  },
};
